
<field-item
    :disabled="handler.isDisabled(dynamicInputProp, parentTreeContext)"
    @click="select(dynamicInputsSection.select(dynamicInputProp, path))"
>
  <row>
    <prefix>
      <icon :glyph="dynamicInputGlyph(dynamicInputProp)"/>
    </prefix>
    <column>
      {{ dynamicInputProp.name }}
    </column>
  </row>
</field-item>
